export default __webpack_public_path__ + "static/media/CV.208b4ad8.pdf";